import { ApiError, ErrorResponseDto } from '@pro4-erp/core-web';
import { ResetPasswordPageProps, ResetPasswordData } from '../types';
import env from '@/env';
import { jsonifyEscape } from '@/core';

export const validateRecoverHash = async ({
  recoverHash,
}: ResetPasswordPageProps): Promise<ResetPasswordData> => {
  const fetchResponse = await fetch(
    `${env.VITE_API_URL}/pb/s/api/sqo-portal/auth/validate-recover-hash`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ recoverHash }),
    }
  );

  if (!fetchResponse.ok) {
    const error = JSON.parse(jsonifyEscape(await fetchResponse.text())) as ErrorResponseDto;
    throw new ApiError(error);
  }

  const response = (await fetchResponse.json()) as ResetPasswordData;
  return response;
};
